import type { ButtonHTMLAttributes } from 'react'

type SecondaryButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  fullWidthOnMobile?: boolean
}

// Secondary action: 1px navy outline, no fill, 48px tall, sharp corners.
export default function SecondaryButton({
  className = '',
  fullWidthOnMobile = true,
  children,
  type = 'button',
  ...rest
}: SecondaryButtonProps) {
  return (
    <button
      type={type}
      {...rest}
      className={[
        'inline-flex h-12 items-center justify-center px-8',
        'border border-ob-ink bg-transparent font-body text-base font-semibold text-ob-ink',
        'rounded-none transition-colors hover:bg-ob-ink/5',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-ob-ink focus-visible:ring-offset-2 focus-visible:ring-offset-ob-surface',
        fullWidthOnMobile ? 'w-full sm:w-auto' : '',
        className,
      ].join(' ')}
    >
      {children}
    </button>
  )
}
